
import useAllUsers from "@/utils/fetchAllUsers.js";
import {useState, useRef} from "react";
import { SearchOutlined } from '@ant-design/icons';
import { Input, Space, Table, Tag, Button} from 'antd';
import Highlighter from 'react-highlight-words';
import UserModal from '../../components/AdminPanel/UserModal.jsx';


const UsersPage = () => {
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editingUser, setEditingUser] = useState(null);

    const openCreateModal = () => {
        setEditingUser(null);
        setIsModalOpen(true);
    };

    const openEditModal = (user) => {
        setEditingUser(user);
        setIsModalOpen(true);
    };

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };

    const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText('');
    };

    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
            <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
                <Input
                    ref={searchInput}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"

                    >
                        Search
                    </Button>
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters)}
                        size="small"

                    >
                        Reset
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            confirm({ closeDropdown: false });
                            setSearchText((selectedKeys )[0]);
                            setSearchedColumn(dataIndex);
                        }}
                    >
                        Filter
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            close();
                        }}
                    >
                        Close
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined style={{ color: filtered ? '#1677ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes((value).toLowerCase()),
    filterDropdownProps: {
        onOpenChange(open) {
            if (open) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },
    },
    render: (text) =>
        searchedColumn === dataIndex ? (
            <Highlighter
                highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                searchWords={[searchText]}
                autoEscape
                textToHighlight={text ? text.toString() : ''}
            />
        ) : (
            text
        ),
});

    const columns = [
        {
            title: 'Name',
            dataIndex: 'email',
            key: 'name',
            width: '30%',
            ...getColumnSearchProps('email'),
        },
        {
            title: 'Balance',
            dataIndex: 'balance',
            key: 'balance',
            width: '20%',
            ...getColumnSearchProps('balance'),
        },
        {
            title: 'Org',
            dataIndex: 'organization',
            key: 'organization',
            ...getColumnSearchProps('organization'),
        },
        {
            title: 'Telegram',
            dataIndex: 'telegram',
            key: 'telegram',
            ...getColumnSearchProps('telegram'),
            sorter: (a, b) => a.telegram?.length - b.telegram?.length,
            sortDirections: ['descend', 'ascend'],
        },

        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (_, { status }) => {
                let color;
                switch (status.toLowerCase()) {
                    case 'moderation':
                        color = 'orange';
                        break;
                    case 'finished':
                        color = 'green';
                        break;
                    case 'on process':
                        color = 'blue';
                        break;
                    case 'rejected':
                        color = 'volcano';
                        break;
                    default:
                        color = 'gray';
                }
                return <Tag color={color}>{status.toUpperCase()}</Tag>;
            }
        },
        {
            title: 'Edit',
            key: 'x',
            render: (_, record) => (
                <a onClick={() => openEditModal(record)}>
                    Edit
                </a>
            ),
        },
    ];

    const {users, refetchUsers} = useAllUsers();

    return (
        <div className="users-page">
            <div className="wrapper">
              <h2> Users </h2>
                <div className="page page-app">

                    <Table columns={columns} dataSource={users} />

                </div>
            </div>
            <UserModal
                open={isModalOpen}
                user={editingUser}
                onCancel={() => setIsModalOpen(false)}
                onSuccess={() => {
                    setIsModalOpen(false);
                  refetchUsers()
                }}
            />
        </div>
    )
}

export default UsersPage;